export default "__VITE_ASSET__Dy0_yfUB__"